import {Injectable} from '@angular/core'
import {HttpClient, HttpParams} from '@angular/common/http'

import {Observable} from 'rxjs'
import {tap} from 'rxjs/operators'

import {LoggerService} from '@app/core/services/logger.service'

import {ApiSearchRequest, ApiSearchResponse} from '../api.interface'
import {Role, Mask, Permission} from '../rest-api.model'
export {Role, Permission}

export interface GetRolesRequest extends ApiSearchRequest {
  domain: string
}
export interface GetRolesResponse extends ApiSearchResponse<Role> {}

@Injectable()
export class RoleService {
  constructor(
    private http: HttpClient,
    private logger: LoggerService,
  ) {}

  public getRoles(request: GetRolesRequest): Observable<GetRolesResponse> {
    const url = 'api://Domains/' + request.domain + '/Roles'

    // convert all object properties to strings
    let params = new HttpParams()
    if (request.search) {
      params = params.set('search', request.search)
    }
    if (request.sort) {
      params = params
        .set('sort', request.sort)
        .set('asc', !request.asc ? 'false' : 'true')
    }
    if (request.offset) {
      params = params.set('offset', request.offset.toString())
    }
    if (request.results) {
      params = params.set('results', request.results.toString())
    }

    return this.http.get<GetRolesResponse>(url, {params: params}).pipe(
      tap((res) => {
        this.logger.log(res)
      }),
    )
  }

  public getRole(domain: string, id: number): Observable<Role> {
    const url = 'api://Domains/' + domain + '/Roles/' + id

    return this.http.get<Role>(url).pipe(
      tap((res) => {
        this.logger.log(res)
      }),
    )
  }

  public postRole(domain: string, role: Role): Observable<Role> {
    const url = 'api://Domains/' + domain + '/Roles'

    return this.http.post<Role>(url, role).pipe(
      tap((res) => {
        this.logger.log(res)
      }),
    )
  }

  public putRole(domain: string, id: number, role: Role): Observable<Role> {
    const url = 'api://Domains/' + domain + '/Roles/' + id
    console.log('putting role', role)
    return this.http.put<Role>(url, role).pipe(
      tap((res) => {
        this.logger.log(res)
      }),
    )
  }

  public deleteRole(domain: string, id: number): Observable<void> {
    const url = 'api://Domains/' + domain + '/Roles/' + id

    return this.http.delete<void>(url)
  }

  public getRolePermissions(
    domain: string,
    id: number,
  ): Observable<Permission[]> {
    const url = 'api://Domains/' + domain + '/Roles/' + id + '/Permissions'

    return this.http.get<Permission[]>(url).pipe(
      tap((res) => {
        this.logger.log(res)
      }),
    )
  }

  public putRolePermissions(
    domain: string,
    id: number,
    permissions: string[],
  ): Observable<Permission[]> {
    const url = 'api://Domains/' + domain + '/Roles/' + id + '/Permissions'

    return this.http.put<Permission[]>(url, permissions).pipe(
      tap((res) => {
        this.logger.log(res)
      }),
    )
  }

  public getRoleMask(domain: string, id: number): Observable<Mask> {
    const url = 'api://Domains/' + domain + '/Roles/' + id + '/Mask'

    return this.http.get<Mask>(url).pipe(
      tap((res) => {
        this.logger.log(res)
      }),
    )
  }

  public getRoleMaskVisibleSettings(
    domain: string,
    id: number,
  ): Observable<string[]> {
    const url = 'api://Domains/' + domain + '/Roles/' + id + '/Mask/Visible'

    return this.http.get<string[]>(url).pipe(
      tap((res) => {
        this.logger.log(res)
      }),
    )
  }

  public putRoleMaskVisibleSettings(
    domain: string,
    id: number,
    settings: string[],
  ): Observable<string[]> {
    const url = 'api://Domains/' + domain + '/Roles/' + id + '/Mask/Visible'

    return this.http.put<string[]>(url, settings).pipe(
      tap((res) => {
        this.logger.log(res)
      }),
    )
  }

  public getRoleMaskEditableSettings(
    domain: string,
    id: number,
  ): Observable<string[]> {
    const url = 'api://Domains/' + domain + '/Roles/' + id + '/Mask/Editable'

    return this.http.get<string[]>(url).pipe(
      tap((res) => {
        this.logger.log(res)
      }),
    )
  }

  public putRoleMaskEditableSettings(
    domain: string,
    id: number,
    settings: string[],
  ): Observable<string[]> {
    const url = 'api://Domains/' + domain + '/Roles/' + id + '/Mask/Editable'

    return this.http.put<string[]>(url, settings).pipe(
      tap((res) => {
        this.logger.log(res)
      }),
    )
  }
}
